import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const qc = useQueryClient();
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (!user) return;
    const beat = () => api.post("/auth/heartbeat").catch(() => {});
    beat();
    const id = setInterval(beat, 60_000);
    return () => clearInterval(id);
  }, [user]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pp_token", data.access_token);
    qc.clear();
    setUser(data.user);
    return data.user;
  }, [qc]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("pp_token");
    qc.clear();
    setUser(false);
  }, [qc]);

  const adoptSession = useCallback((data) => {
    localStorage.setItem("pp_token", data.access_token);
    qc.clear();
    setUser(data.user);
  }, [qc]);

  return <AuthContext.Provider value={{ user, setUser, login, logout, adoptSession }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
